const $ = window.jQuery;
export default $;
export const jQuery = $;
